module.exports = __webpack_public_path__ + "img/ice_cream.cd11c9fb.svg";